import { Link } from "react-router-dom";

const MainFooter = () => {
  return (
    <footer>
      <div className="width">
        <div className="ft_top">
          <Link to="/" className="flogo">
            <img src="/assets/img/flogo.png" alt="" />
          </Link>
          <ul>
            <li>
              <Link to="/Public/Privacy">개인정보처리방침</Link>
            </li>
            <li>
              <Link to="/Public/Term">서비스이용약관</Link>
            </li>
          </ul>
        </div>
        <div className="ft_bot">
          <p>
            [05505] 서울특별시 송파구 올림픽로43길 88 서울아산병원 신관 6층
            신생아과 의국
          </p>
          <h6>(c) 2025. K-CDH All rights reserved.</h6>
        </div>
      </div>
    </footer>
  );
};

export default MainFooter;
